// Module
var code = "<workshop-host></workshop-host>";
// Exports
module.exports = code;